module.exports = __webpack_public_path__ + "img/scissors-icon.51a3b1fa.png";